import { Select } from "@/ui";
import { SharedProps } from "@/types";
import { m } from "@/paraglide/messages";
import { setLocale, Locale } from "@/paraglide/runtime";
import { usePage } from "@inertiajs/react";

import styles from "./LayoutFooter.module.css";

export default function LayoutFooter() {
  const { locale } = usePage<SharedProps>().props;

  const switchLanguage = (locale: Locale) => setLocale(locale);

  return (
    <footer className={styles.footer}>
      <div className={styles.copyright}>
        <p>{m["footer.copyright"]()}</p>
        <p>
          <em>{m["footer.trademarks"]()}</em>
        </p>
      </div>
      <div>
        <label htmlFor="language">{m["footer.switch_language"]()}</label>
        <Select
          id="language"
          defaultValue={locale}
          onChange={(e) => switchLanguage(e.target.value as Locale)}
        >
          <Select.Option value="en">English</Select.Option>
          <Select.Option value="es">Español</Select.Option>
        </Select>
      </div>
    </footer>
  );
}
